export default __webpack_public_path__ + "static/media/eghtesad-100_new.a29d0da2.png";